module.exports = __webpack_public_path__ + "img/svg/competition-card-hover.7aff17c161c07206061f7f2e5870b6e7.svg";